import { DIM } from '../../configs/config'
import { Ghost, withRipple } from '../../base/components/advanced/ghost/ghost'
import { Base } from '../../base/components/base'
import router from '../../base/lib/router'
import {emitter} from '../../base/utils/emitter'
import { MenuIconBar } from './menu-icon-bar'
import { CENTER, WH } from '../../base/helpers/style'

export const MenuIcon = () => {

    const height = 4
    const base = Base('div')
    const top = MenuIconBar(height)
    const middle = MenuIconBar(height)
    const bottom = MenuIconBar(height)

    const ghost = Ghost({ bg: 'white' })

    emitter.on('route-changed', (r: string) =>  r == '/' ? show() : hide())
    base.el.onclick = () => {
        console.log('menu clicked');
        
        router.goto('/menu')
    }

    base.el.addEventListener('touchstart', (e) => {
        ghost.activate(e.touches[0].pageX, e.touches[0].pageY)
        base.style({
            transform: 'scale(.9)'
        })
    })
    base.el.addEventListener('touchend', () => {
        ghost.deactivate()
        base.style({
            transform: 'scale(1)'
        })
    })
    base.append(top, middle, bottom, ghost)

    base.cssClass({
        ...WH(20),
        margin: '20px',
        transition: 'all .16s',
        zIndex: '999',
        ...CENTER,
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer'
    })

    withRipple(base)

    function show() {
        base.style({
            opacity: '1',
            transform: 'translateY(0)'
        }, {delay: 100})
    }
    function hide() {
        base.style({
            opacity: '0',
            transform: 'translateY(-50px)'
        })
    }

  
    return base
}